const mapKeys = (data = [], key) => {
  return data.reduce((obj, n) => {
    obj[n[key]] = n;
    return obj;
  }, {});
};

export default mapKeys;
